export enum ReportPeriodGroupingEnum {
  EntirePeriod = "EntirePeriod",
  Monthly = "Monthly",
  Weekly = "Weekly",
  Daily = "Daily",
}
